import { useEffect } from 'react'
import { useEmotesMuted } from '../../../sharedComponents/src/settings/emotesMuted'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import { GameViewState } from '../GameViewModel'
import { EMOTES_ENABLED } from './EmotesModel'

// Owns the emote session of the PvP view: one per game, loaded as soon as the match is known (preloading, so the
// list is in before the game starts), ended with the game (new game / rematch / non-PvP) or when leaving the view.
export const useEmoteSession = () => {
    const gameData = useStoreState((state) => state.gameView.gameData)
    const gameState = useStoreState((state) => state.gameView.gameState)
    const sessionMatchId = useStoreState((state) => state.emotes.matchId)
    const postGameSocket = useStoreState((state) => !!state.gameView.postGameSocket)
    const muted = useEmotesMuted()

    const fetchCatalogue = useStoreActions((actions) => actions.emotes.fetchCatalogue)
    const startSession = useStoreActions((actions) => actions.emotes.startSession)
    const clearOpponentBubbles = useStoreActions((actions) => actions.emotes.clearOpponentBubbles)
    const clearPostGameSocket = useStoreActions((actions) => actions.gameView.clearPostGameSocket)

    const pvpMatchId = EMOTES_ENABLED && gameData?.matchKind === 'human_vs_human' ? gameData.matchId : undefined

    // a game that ended before its list was requested can still load it for the post-game socket
    const canEmote =
        gameState === GameViewState.GAME_PRELOADING ||
        gameState === GameViewState.GAME_RUNNING ||
        (gameState === GameViewState.GAME_OVER && postGameSocket)

    useEffect(() => {
        if (pvpMatchId === sessionMatchId) return
        if (pvpMatchId && canEmote) fetchCatalogue(pvpMatchId)
        else if (sessionMatchId) startSession(undefined)
    }, [pvpMatchId, sessionMatchId, canEmote])

    useEffect(() => {
        if (muted) clearOpponentBubbles()
    }, [muted])

    useEffect(
        () => () => {
            clearPostGameSocket(undefined)
            startSession(undefined)
        },
        [],
    )
}
